import dayjs from "dayjs"

export const getLastUpdateTimeStr = (lastUpdateStr) => {
  const now = dayjs()
  const lastUpdate = dayjs(lastUpdateStr)
  const diffMinutes = now.diff(lastUpdate, "minute")
  const diffHours = now.diff(lastUpdate, "hour")
  const diffDays = now.diff(lastUpdate, "day")

  if (diffMinutes < 1) {
    return "Just now"
  } else if (diffMinutes < 60) {
    return `${diffMinutes} minute${diffMinutes > 1 ? "s" : ""} ago`
  } else if (diffHours < 24) {
    return `${diffHours} hour${diffHours > 1 ? "s" : ""} ago`
  } else {
    const remainingHours = diffHours % 24
    return `${diffDays} day${
      diffDays > 1 ? "s" : ""
    } and ${remainingHours} hour${remainingHours !== 1 ? "s" : ""} ago`
  }
}
